module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_voted.7cd1f.png";